import React from 'react';
import { Row, Col } from 'antd';
import { Paper } from '@material-ui/core';
import CustomerDetails from './CustomerDetails';
import Marketing from './Marketing';
import BikeDetails from './BikeDetails';
import Valuations from './Valuations';
import CapValuation from './CapValuation';
import MotHistory from './MotHistory';
import ExistingStock from './ExistingStock';
import LeadomaticInfo from './LeadomaticInfo';
import VRMDuplicates from './VRMDuplicates';
import CustomerWants from './CustomerWants';
import BikeFaultNotes from './BikeFaultNotes';
import ModelPriceSuggestions from './ModelPriceSuggestions';

export default function LeadProfileTable() {
    return (
        <div className="customerSideBar">
            <Paper style={{ padding: 24 }}>
                <Row>
                    <Col span={12}>
                        <Col span={24}>
                            <Row className="crmDetails">
                                <BikeDetails />
                            </Row>
                            <Row className="crmDetails">
                                <CustomerDetails />
                            </Row>
                            <Row className="crmDetails">
                                <BikeFaultNotes />
                            </Row>
                            <Row className="crmDetails">
                                <ModelPriceSuggestions />
                            </Row>
                            <Row className="crmDetails">
                                <Marketing />
                            </Row>
                            <Row className="crmDetails">
                                <LeadomaticInfo />
                            </Row>
                        </Col>
                    </Col>
                    <Col span={12}>
                        <VRMDuplicates />
                        <CustomerWants />
                        <Valuations />
                        <CapValuation />
                        <MotHistory />
                        <ExistingStock />
                    </Col>
                </Row>
            </Paper>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/LeadProfileTable.js